// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as FlipperStoreTypes$LiteracyplanetClientSxActivity from "./FlipperStoreTypes.res.mjs";

function useResultsDispatch() {
  var match = FlipperStoreTypes$LiteracyplanetClientSxActivity.use();
  var dispatch = match[1];
  var state = match[0];
  return {
          onResultReady: (function () {
              dispatch("ResultsReady");
            }),
          onExit: (function () {
              dispatch(state.needsToShowMissionComplete ? "ExitToMissions" : "Exit");
            }),
          onFailed: (function (param) {
              
            }),
          onRetryActivity: (function () {
              location.reload();
              dispatch("Exit");
            }),
          onGoToCollections: (function () {
              dispatch("ExitToCollections");
            })
        };
}

function defaultCb(param) {
  
}

var defaultResultDispatchables = {
  onResultReady: defaultCb,
  onExit: defaultCb,
  onFailed: defaultCb,
  onRetryActivity: defaultCb,
  onGoToCollections: defaultCb
};

var context = React.createContext(defaultResultDispatchables);

function makeProps(value, children, param) {
  return {
          value: value,
          children: children
        };
}

var make = context.Provider;

function use() {
  return React.useContext(context);
}

var Context = {
  context: context,
  makeProps: makeProps,
  make: make,
  use: use
};

function FlipperCobraResultsCallbacks$Provider(props) {
  return React.createElement(make, {
              value: props.dispachables,
              children: props.children
            });
}

var Provider = {
  make: FlipperCobraResultsCallbacks$Provider
};

export {
  useResultsDispatch ,
  defaultCb ,
  defaultResultDispatchables ,
  Context ,
  Provider ,
}
/* context Not a pure module */
